// // import React from 'react';
// import ReactDOM from 'react-dom/client';
// import 'bootstrap/dist/css/bootstrap.css';
// import './index.css';
// import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   // <React.StrictMode>
//     <App />
//   // </React.StrictMode>
// );

///////

// import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
// import Home from "./pages/Home";
import Browse from "./pages/Browse";
import Project from "./pages/Project";
import FAQ from "./pages/FAQ";
// import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";
import Create from "./pages/Create";


const basename = process.env.NODE_ENV === 'production' ? '/project-type-1' : '';

export default function App2() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* <Route index element={<Home />} /> */}
          <Route index element={<Create />} />
          <Route path="create" element={<Create />} />
          <Route path="browse" element={<Browse />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="project" element={<Project />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

// ReactDOM.render(<App2 />, document.getElementById("root"));

const root = createRoot(document.getElementById("root"));
root.render(<App2 />);